import script from "./SddsIconCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./SddsIconCustom.vue?vue&type=script&setup=true&lang=js"

import "./SddsIconCustom.vue?vue&type=style&index=0&id=664c3925&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664c3925"]])

export default __exports__